
import { Component, Vue } from 'vue-property-decorator';
import { IHandledExceptionResponse } from '@/models/core/IHandledExceptionResponse';
import { LocalizationUtil } from '@/utils/LocalizationUtil';

@Component
export default class OsBusinessErrorResponseDialog extends Vue {
  visible = false;
  businessError: IHandledExceptionResponse = {
    message: '',
    dependingEntities: []
  };

  open(businessError: IHandledExceptionResponse) {
    this.businessError = businessError;
    this.visible = true;
  }

  close() {
    this.visible = false;
  }

  localizeError(key: string) {
    return LocalizationUtil.localize(key);
  }
}
